<div class="form-container">
  <form [formGroup]="form">
    <h1 class="title">Cadastro</h1>

    <div class="profile-image-container" (click)="changeAvatar()">
      <img [src]="avatar ? avatar : '../../../assets/icons/default-user-icon-profile.png'" src="" id="profile-image" />
    </div>
    <button mat-raised-button (click)="changeAvatar()" class="btn-segundary">Adicionar foto</button>
    <br />
    <mat-form-field appearance="outline" id="name">
      <mat-label>Nome</mat-label>
      <input matInput placeholder="Nome" formControlName="name" name="name" autocomplete="name" />
      <mat-error *ngIf="form.controls.name.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <div class="gender-container">
      <label id="example-radio-group-label">Sexo:</label>
      <br />
      <mat-radio-group
        aria-label="Select an option"
        formControlName="gender"
        color="primary"
        class="gender"
        aria-autocomplete="both"
      >
        <mat-radio-button value="M">Masculino</mat-radio-button>
        <mat-radio-button value="F">Feminino</mat-radio-button>

        <mat-error *ngIf="form.controls.gender.hasError('required')"> Obrigatorio </mat-error>
      </mat-radio-group>
    </div>
    <br />

    <mat-form-field appearance="outline">
      <mat-label>CPF</mat-label>
      <input
        formControlName="cpf"
        autocomplete="off"
        type="text"
        matInput
        appCpf
        placeholder="000.000.000-00"
        appCpfMaskTwo
        maxlength="14"
      />
      <mat-error *ngIf="form.controls.cpf.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>E-mail</mat-label>
      <input matInput placeholder="email" formControlName="email" autocomplete="email" />

      <mat-error *ngIf="form.controls.email.hasError('email')"> Email invalido </mat-error>
      <mat-error *ngIf="form.controls.email.hasError('required')"> Obrigatorio </mat-error>
      <mat-error *ngIf="form.controls.email.hasError('maxlength')">O máximo são 100 caracteres </mat-error>
    </mat-form-field>

    <br />

    <mat-form-field appearance="outline">
      <mat-label>Celular</mat-label>
      <input matInput placeholder="(82) 98121-3141" formControlName="phone_number" appPhoneMask maxlength="14" />
      <mat-error *ngIf="form.controls.phone_number.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Data de nascimento</mat-label>
      <input matInput placeholder="email" formControlName="bhirth_date" type="date" />
      <mat-error *ngIf="form.controls.bhirth_date.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field appearance="outline">
      <mat-label>CEP</mat-label>
      <input
        formControlName="cep"
        autocomplete="off"
        type="text"
        matInput
        appCepMask
        placeholder="00000-000"
        maxlength="9"
      />
      <mat-error *ngIf="form.controls.cep.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>endereço</mat-label>
      <input matInput placeholder="endereço" formControlName="street" />
      <mat-error *ngIf="form.controls.street.hasError('required')"> Obrigatorio </mat-error>
      <mat-error *ngIf="form.controls.street.hasError('maxlength')">O máximo são 100 caracteres </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Complemento</mat-label>
      <input matInput placeholder="Complemento" formControlName="complement" />
      <mat-error *ngIf="form.controls.complement.hasError('maxlength')">O máximo são 100 caracteres </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" id="home_number">
      <mat-label>Nº</mat-label>
      <input matInput placeholder="nº" formControlName="home_number" />
      <mat-error *ngIf="form.controls.home_number.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field appearance="outline">
      <mat-label>Estado</mat-label>
      <mat-select matNativeControl (selectionChange)="changeCity($event.value)" formControlName="state_id">
        <mat-option *ngFor="let state of states" [value]="state.ID">
          {{ state.Nome }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Cidade</mat-label>
      <mat-select matNativeControl formControlName="city_id">
        <mat-option *ngFor="let city of cities" [value]="city.ID">
          {{ city.Nome }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <br />

    <mat-form-field appearance="outline">
      <mat-label>Célula</mat-label>
      <select matNativeControl formControlName="group_id">
        <option value="">Selecione</option>
         <option value="">ainda não estou em célula</option>ß
        <option *ngFor="let group of groups" [value]="group.id">
          {{ group.name }}
        </option>
      </select>
      <mat-error *ngIf="form.controls.group_id.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field appearance="outline">
      <mat-label>Tipo sanguineo</mat-label>
      <select matNativeControl formControlName="blood_type" aria-placeholder="selecione">
        <option >Selecione</option>
        <option value="">não sei ou não quero informar</option>
        <option *ngFor="let blood of bloods" [value]="blood">{{ blood }}</option>
      </select>
      <mat-error *ngIf="form.controls.blood_type.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <br />

    <div class="term">
      <p>Ao clicar em cadastrar você concorda com os nossos <a routerLink="/terms" target="_blank">Termos de uso</a></p>
    </div>

    <br />

    <button *ngIf="!id" (click)="register()" mat-raised-button class="btn-primary">Cadastrar</button>
    <br />
    <button mat-raised-button [routerLink]="['/']" class="btn-segundary">Cancelar</button>
    <br />
    <br />
  </form>
</div>
